import { useCallback, useRef } from 'react'

export const useDebouncedCallback = <T extends (...args: any[]) => void>(
  func: T,
  wait: number,
): ((...args: Parameters<T>) => void) => {
  const timeout = useRef<ReturnType<typeof setTimeout>>(null)

  return useCallback(
    (...args: Parameters<T>) => {
      const later = () => {
        if (timeout.current) clearTimeout(timeout.current)
        func(...args)
      }

      if (timeout.current) clearTimeout(timeout.current)
      timeout.current = setTimeout(later, wait)
    },
    [func, wait],
  )
}
